import React from "react";

import { Typography } from "@mui/material";

import CommandIconActif from "../../../../Assets/svg/menu/CommandActif";
import CustomHeader from "../CustomHeader/CustomHeader";

const HeaderCommand: React.FC = () => (
  <CustomHeader
    childLeft={
      <div
        style={{
          alignItems: "flex-start",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          style={{ fontSize: 24, fontWeight: "bold", color: "#ffffff" }}
        >
          Commandes
        </Typography>
      </div>
    }
    icon={
      <CommandIconActif
        viewBox="100 20 130 130"
        fill="#ffffff50"
        style={{
          height: "138px",
          width: "425px",
        }}
      />
    }
  />
);

export default HeaderCommand;
